import { UIElement } from '../ui-element';
import { Digest } from '../../global/digest';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import styles from './ui-legalblock.css';
import { UILegalBlockColor, UILegalBlockColors } from './ui-legalblock.type';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UILegalBlock
 * @element ui-legalblock
 * @classdesc Represents a class for <code>ui-legalblock</code> element.
 * Container for legal terms and conditions.
 * @property {UILegalBlockColors} [color="transparent"] {@attr color} color of background.
 *  {@desc transparent: No background color - Default}
 *  {@desc gray: Gray color}
 * @slot
 * @example
 * <ui-legalblock>
 *   By signing this document...
 * </ui-legalblock>
 */
@Component({
    tag: 'ui-legalblock',
    styles,
})
export class UILegalBlock extends UIElement {
    @Attribute(String) color?: UILegalBlockColor;

    private _id!: string;

    /**
     * Background color options.
     * @type {UILegalBlockColor}
     * @readonly
     */
    static readonly colors: UILegalBlockColors = {
        Transparent: 'transparent',
        Gray: 'gray',
    };

    /**
     * @inheritDoc
     */
    render(): void {
        this._id = Digest.randomId();

        const header = this.querySelector<HTMLHeadingElement>('h2,h3');
        if (header && !header.id) {
            header.id = 'ui-legalblock-header-' + this._id;
        }

        const frame = this.querySelector<HTMLElement>('ui-scrollable-frame');
        if (header && frame) {
            frame.setAttribute('aria-labelledby', header.id);
        }
    }
}
